import { notifications } from "@mantine/notifications"
import { AxiosError } from "axios"

import { queryClient } from "~/backend/queryClient"
import {
  findOperationChainItemsQueryKey,
  useDeleteOperationChainItem,
} from "~/gen/api"

export const useDeleteOperationChainItemMutation = () =>
  useDeleteOperationChainItem({
    mutation: {
      onSuccess: async (_, variables) => {
        await queryClient.invalidateQueries(
          findOperationChainItemsQueryKey(variables.operationChainId)
        )
        notifications.show({
          title: "Success",
          message: "Operation chain item deleted",
          color: "teal",
        })
      },
      onError: (error) => {
        if (error instanceof AxiosError) {
          notifications.show({
            title: "Error",
            message:
              "Failed to delete operation chain item cause : " +
              error.response?.data,
            color: "red",
          })
        }
      },
    },
  })
